import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import { useIsClientSideRender } from '@migros/msrc-browser';
import { useEffect, useState } from 'react';
import { dayjs } from './dayjs';
import { jsonFileTranslator, jsonFileTranslatorSetup, loaded } from './json-file-translator';
import { SupportedLanguages } from './translator';
export var useJsonFileTranslator = function useJsonFileTranslator(prefix, translations) {
  return function () {
    var _context, _context2;
    var preferredLanguage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : jsonFileTranslator.language;
    /* eslint-disable react-hooks/rules-of-hooks */
    var isClientSideRender = useIsClientSideRender();
    var language = _includesInstanceProperty(_context = _Object$keys(SupportedLanguages)).call(_context, preferredLanguage) ? preferredLanguage : SupportedLanguages.de;

    // Directly set `currentLanguage` in a SSR Environment since side effects won't work
    var _useState = useState(isClientSideRender ? null : language),
      _useState2 = _slicedToArray(_useState, 2),
      currentLanguage = _useState2[0],
      setCurrentLanguage = _useState2[1];
    var isLoaded = _includesInstanceProperty(_context2 = loaded[language]).call(_context2, prefix);
    var langTranslations = translations[language] || translations[SupportedLanguages.de];
    if (isLoaded) {
      jsonFileTranslator.prefix = prefix;
      jsonFileTranslator.language = language;
      dayjs.locale(language);
    } else if (!isClientSideRender) {
      // Directly setup i18n in a SSR Environment since side effects won't work
      jsonFileTranslatorSetup(language, prefix, langTranslations());
    }
    useEffect(function () {
      if (!isLoaded) {
        jsonFileTranslatorSetup(language, prefix, langTranslations());
        setCurrentLanguage(language);
      }
    }, [language, loaded, jsonFileTranslator.messages]);
    return [jsonFileTranslator, isLoaded || currentLanguage !== null];
  };
};

/**
 * @deprecated Please use useJsonFileTranslator
 */
export var useI18n = useJsonFileTranslator;